// extracted by mini-css-extract-plugin
export var avatarContainer = "_4h-1";
export var largeAvatarContainer = "_4h-2";
export var smallAvatarContainer = "_4h-0";